import { InjectionToken } from '@angular/core';
export var OWL_DATE_TIME_FORMATS = new InjectionToken('OWL_DATE_TIME_FORMATS');



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-pick-datetime/date-time/adapter/date-time-format.class.js
// module id = ./node_modules/ng-pick-datetime/date-time/adapter/date-time-format.class.js
// module chunks = vendor